// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".jumbo-cta--_3d6i .colorful-box--Kdmp3{border-radius:20px;position:relative;overflow:hidden}.jumbo-cta--_3d6i .colorful-box-bg--WUIOv{position:absolute;top:0;left:0;width:100%;height:100%;object-fit:cover;z-index:0}.jumbo-cta--_3d6i .colorful-box--Kdmp3 .row{position:relative;z-index:1}.jumbo-cta--_3d6i .btn-white:hover{color:#5645f5}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"jumbo-cta": "jumbo-cta--_3d6i",
	"colorful-box": "colorful-box--Kdmp3",
	"colorful-box-bg": "colorful-box-bg--WUIOv"
};
export default ___CSS_LOADER_EXPORT___;
